export const GUEST_QA_SECTION_DOC_ID = "guestQA";

export function openUnansweredGuestQuestionCount(property) {
  if (!property || typeof property !== "object") {
    return 0;
  }

  const entries = property.unansweredGuestQuestions;
  if (entries && typeof entries === "object" && !Array.isArray(entries)) {
    return Object.values(entries).filter((entry) => entry?.status === "open")
      .length;
  }

  const count = Number(property.unansweredGuestQuestionCount);
  return Number.isFinite(count) && count > 0 ? count : 0;
}

export function guestQAMenuLabel(property) {
  const count = openUnansweredGuestQuestionCount(property);
  return count > 0 ? `Guest Q&A (${count})` : "Guest Q&A";
}
